module.exports = require('./helpers/bundle-url').getBundleURL('9rAa3') + "key-logo.39b27441.svg";